/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '../context/GsocApolloHooks';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {"context":{"apiName":"DATA_PLANE_API"}} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDateTime: { input: Date; output: Date; }
};

export type AgentPostPassReport = {
  readonly __typename?: 'AgentPostPassReport';
  readonly agentId: Scalars['String']['output'];
  readonly markdownText: Scalars['String']['output'];
  readonly s3Key: Scalars['String']['output'];
  readonly taskDocumentId: Scalars['String']['output'];
};

export type Aggregation = {
  readonly __typename?: 'Aggregation';
  readonly _avg: Scalars['Float']['output'];
  readonly _max: Scalars['Float']['output'];
  readonly _min: Scalars['Float']['output'];
  readonly _p1: Scalars['Float']['output'];
  readonly _p5: Scalars['Float']['output'];
  readonly _p25: Scalars['Float']['output'];
  readonly _p50: Scalars['Float']['output'];
  readonly _p75: Scalars['Float']['output'];
  readonly _p95: Scalars['Float']['output'];
  readonly _p99: Scalars['Float']['output'];
  readonly _stdDev: Scalars['Float']['output'];
  readonly _sum: Scalars['Float']['output'];
};

export type Contact = {
  readonly __typename?: 'Contact';
  readonly agentPostPassReports?: Maybe<ReadonlyArray<AgentPostPassReport>>;
  readonly dataplaneReport?: Maybe<DataplaneReport>;
  readonly id: Scalars['String']['output'];
  readonly images?: Maybe<ReadonlyArray<PostPassImage>>;
  readonly laminarFlowPlots?: Maybe<ReadonlyArray<LaminarFlowPlot>>;
  readonly tracerouteDetails?: Maybe<TracerouteDetails>;
  readonly visualization?: Maybe<ContactVisualization>;
};

export type ContactByIdInput = {
  readonly id: Scalars['String']['input'];
};

export type ContactVisualization = {
  readonly __typename?: 'ContactVisualization';
  readonly dataplaneSvgUrlDark?: Maybe<Scalars['String']['output']>;
  readonly dataplaneSvgUrlLight?: Maybe<Scalars['String']['output']>;
  readonly s3Key?: Maybe<Scalars['String']['output']>;
};

export type CursorPart = {
  readonly __typename?: 'CursorPart';
  readonly key: Scalars['String']['output'];
  readonly value: Scalars['String']['output'];
};

export type CursorPartInput = {
  readonly key: Scalars['String']['input'];
  readonly value: Scalars['String']['input'];
};

export type DdxStatistic = {
  readonly __typename?: 'DDXStatistic';
  readonly avg?: Maybe<Scalars['Float']['output']>;
  readonly median?: Maybe<Scalars['Float']['output']>;
  readonly p50?: Maybe<Scalars['Float']['output']>;
  readonly p75?: Maybe<Scalars['Float']['output']>;
  readonly p90?: Maybe<Scalars['Float']['output']>;
  readonly p95?: Maybe<Scalars['Float']['output']>;
  readonly p99?: Maybe<Scalars['Float']['output']>;
  readonly stdDev?: Maybe<Scalars['Float']['output']>;
};

export type DdxStatisticFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<DdxStatisticFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<DdxStatisticFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<DdxStatisticFilterInput>>;
  readonly avg?: InputMaybe<FloatFilterInput>;
  readonly median?: InputMaybe<FloatFilterInput>;
  readonly p50?: InputMaybe<FloatFilterInput>;
  readonly p75?: InputMaybe<FloatFilterInput>;
  readonly p90?: InputMaybe<FloatFilterInput>;
  readonly p95?: InputMaybe<FloatFilterInput>;
  readonly p99?: InputMaybe<FloatFilterInput>;
  readonly stdDev?: InputMaybe<FloatFilterInput>;
};

export type DdxStreamMetric = {
  readonly __typename?: 'DDXStreamMetric';
  readonly dataLatency?: Maybe<DdxStatistic>;
  readonly dataPacketsReceived?: Maybe<Scalars['Int']['output']>;
  readonly dataRate?: Maybe<DdxStatistic>;
  readonly streamDirection: Scalars['String']['output'];
  readonly streamId: Scalars['String']['output'];
  readonly streamName: Scalars['String']['output'];
  readonly wanLatency?: Maybe<DdxStatistic>;
  readonly wanOverhead?: Maybe<DdxStatistic>;
  readonly wanPacketsDropped?: Maybe<Scalars['Int']['output']>;
  readonly wanPacketsDuplicated?: Maybe<Scalars['Int']['output']>;
  readonly wanPacketsLost?: Maybe<Scalars['Int']['output']>;
  readonly wanPacketsReceived?: Maybe<Scalars['Int']['output']>;
  readonly wanPacketsReordered?: Maybe<Scalars['Int']['output']>;
  readonly wanPacketsRepaired?: Maybe<Scalars['Int']['output']>;
  readonly wanRate?: Maybe<DdxStatistic>;
  readonly wanRtt?: Maybe<DdxStatistic>;
};

export type DdxStreamMetricFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<DdxStreamMetricFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<DdxStreamMetricFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<DdxStreamMetricFilterInput>>;
  readonly dataLatency?: InputMaybe<DdxStatisticFilterInput>;
  readonly dataPacketsReceived?: InputMaybe<IntegerFilterInput>;
  readonly dataRate?: InputMaybe<DdxStatisticFilterInput>;
  readonly streamDirection?: InputMaybe<StringFilterInput>;
  readonly streamId?: InputMaybe<StringFilterInput>;
  readonly streamName?: InputMaybe<StringFilterInput>;
  readonly wanLatency?: InputMaybe<DdxStatisticFilterInput>;
  readonly wanOverhead?: InputMaybe<DdxStatisticFilterInput>;
  readonly wanPacketsDropped?: InputMaybe<IntegerFilterInput>;
  readonly wanPacketsDuplicated?: InputMaybe<IntegerFilterInput>;
  readonly wanPacketsLost?: InputMaybe<IntegerFilterInput>;
  readonly wanPacketsReceived?: InputMaybe<IntegerFilterInput>;
  readonly wanPacketsReordered?: InputMaybe<IntegerFilterInput>;
  readonly wanPacketsRepaired?: InputMaybe<IntegerFilterInput>;
  readonly wanRate?: InputMaybe<DdxStatisticFilterInput>;
  readonly wanRtt?: InputMaybe<DdxStatisticFilterInput>;
};

export type DataPlaneDdxMetric = {
  readonly __typename?: 'DataPlaneDDXMetric';
  /** The account of the CPS account for the job */
  readonly accountId: Scalars['String']['output'];
  /** Unique identifier for the contact */
  readonly contactId: Scalars['String']['output'];
  readonly customerNamePart?: Maybe<Scalars['String']['output']>;
  /** The end of the contact time */
  readonly endTime: Scalars['String']['output'];
  /** Unique indentifier for the DDX job */
  readonly jobId: Scalars['String']['output'];
  /** The end of post-pass */
  readonly postPassEndTime: Scalars['String']['output'];
  /** The start time of pre-pass */
  readonly prePassStartTime: Scalars['String']['output'];
  /** The CPS region of the the account running the job */
  readonly region: Scalars['String']['output'];
  /** The start of the contact time */
  readonly startTime: Scalars['String']['output'];
  readonly streamMetrics: ReadonlyArray<DdxStreamMetric>;
};

export type DataPlaneDdxMetricFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<DataPlaneDdxMetricFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<DataPlaneDdxMetricFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<DataPlaneDdxMetricFilterInput>>;
  readonly accountId?: InputMaybe<StringFilterInput>;
  readonly contactId?: InputMaybe<StringFilterInput>;
  readonly customerNamePart?: InputMaybe<StringFilterInput>;
  readonly endTime?: InputMaybe<StringFilterInput>;
  readonly jobId?: InputMaybe<StringFilterInput>;
  readonly postPassEndTime?: InputMaybe<StringFilterInput>;
  readonly prePassStartTime?: InputMaybe<StringFilterInput>;
  readonly region?: InputMaybe<StringFilterInput>;
  readonly startTime?: InputMaybe<StringFilterInput>;
  readonly streamMetrics?: InputMaybe<DdxStreamMetricFilterInput>;
};

export type DataPlaneDdxMetricSortInput = {
  readonly accountId?: InputMaybe<SortOrder>;
  readonly contactId?: InputMaybe<SortOrder>;
  readonly customerNamePart?: InputMaybe<SortOrder>;
  readonly endTime?: InputMaybe<SortOrder>;
  readonly jobId?: InputMaybe<SortOrder>;
  readonly postPassEndTime?: InputMaybe<SortOrder>;
  readonly prePassStartTime?: InputMaybe<SortOrder>;
  readonly region?: InputMaybe<SortOrder>;
  readonly startTime?: InputMaybe<SortOrder>;
};

export type DataPlaneLfMetric = {
  readonly __typename?: 'DataPlaneLFMetric';
  readonly agentInformation?: Maybe<LaminarFlowAgentMetadata>;
  readonly agent_id: Scalars['String']['output'];
  readonly contactStatus?: Maybe<Scalars['String']['output']>;
  readonly contact_id: Scalars['String']['output'];
  readonly customerId?: Maybe<Scalars['String']['output']>;
  readonly customerNamePart?: Maybe<Scalars['String']['output']>;
  readonly dataflow_id: Scalars['String']['output'];
  readonly destinationRegion?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly lfDecryptStageMetricsV2?: Maybe<LfDecryptStageMetricsV2>;
  readonly lfEgressStageMetricsV2?: Maybe<LfEgressStageMetricsV2>;
  readonly lfEncryptStageMetricsV2?: Maybe<LfEncryptStageMetricsV2>;
  readonly lfIngressStageMetricsV2?: Maybe<LfIngressStageMetricsV2>;
  readonly lfStripeDecodeStageMetricsV2?: Maybe<LfStripeDecodeStageMetricsV2>;
  readonly lfStripeDecodeStageMetricsV3?: Maybe<LfStripeDecodeStageMetricsV3>;
  readonly lfStripeEncodeStageMetricsV2?: Maybe<LfStripeEncodeStageMetricsV2>;
  readonly lfTimeDecodeStageMetricsV2?: Maybe<LfTimeDecodeStageMetricsV2>;
  readonly lfTimeDecodeStageMetricsV3?: Maybe<LfTimeDecodeStageMetricsV3>;
  readonly lfTimeEncodeStageMetricsV2?: Maybe<LfTimeEncodeStageMetricsV2>;
  readonly lfTracerouteStageMetricsV2?: Maybe<ReadonlyArray<LfTracerouteStageMetricsV2>>;
  readonly lfWanRxStageMetricsV2?: Maybe<LfWanRxStageMetricsV2>;
  readonly lfWanTxStageMetricsV2?: Maybe<LfWanTxStageMetricsV2>;
  readonly missionProfileId?: Maybe<Scalars['String']['output']>;
  readonly rpm_version: Scalars['String']['output'];
  readonly sourceRegion?: Maybe<Scalars['String']['output']>;
  readonly task_id: Scalars['String']['output'];
  readonly timeStampEnd?: Maybe<Scalars['String']['output']>;
  readonly timeStampStart?: Maybe<Scalars['String']['output']>;
};

export type DataPlaneLfMetricAggregation = {
  readonly __typename?: 'DataPlaneLFMetricAggregation';
  readonly lfDecryptStageMetricsV2: LfDecryptStageMetricsV2Aggregation;
  readonly lfEgressStageMetricsV2: LfEgressStageMetricsV2Aggregation;
  readonly lfEncryptStageMetricsV2: LfEncryptStageMetricsV2Aggregation;
  readonly lfIngressStageMetricsV2: LfIngressStageMetricsV2Aggregation;
  readonly lfStripeDecodeStageMetricsV2: LfStripeDecodeStageMetricsV2Aggregation;
  readonly lfStripeDecodeStageMetricsV3: LfStripeDecodeStageMetricsV3Aggregation;
  readonly lfStripeEncodeStageMetricsV2: LfStripeEncodeStageMetricsV2Aggregation;
  readonly lfTimeDecodeStageMetricsV2: LfTimeDecodeStageMetricsV2Aggregation;
  readonly lfTimeDecodeStageMetricsV3: LfTimeDecodeStageMetricsV3Aggregation;
  readonly lfTimeEncodeStageMetricsV2: LfTimeEncodeStageMetricsV2Aggregation;
  readonly lfWanRxStageMetricsV2: LfWanRxStageMetricsV2Aggregation;
  readonly lfWanTxStageMetricsV2: LfWanTxStageMetricsV2Aggregation;
};

export type DataPlaneLfMetricFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<DataPlaneLfMetricFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<DataPlaneLfMetricFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<DataPlaneLfMetricFilterInput>>;
  readonly agentInformation?: InputMaybe<LaminarFlowAgentMetadataFilterInput>;
  readonly agent_id?: InputMaybe<StringFilterInput>;
  readonly contactStatus?: InputMaybe<StringFilterInput>;
  readonly contact_id?: InputMaybe<StringFilterInput>;
  readonly customerId?: InputMaybe<StringFilterInput>;
  readonly customerNamePart?: InputMaybe<StringFilterInput>;
  readonly dataflow_id?: InputMaybe<StringFilterInput>;
  readonly destinationRegion?: InputMaybe<StringFilterInput>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly lfDecryptStageMetricsV2?: InputMaybe<LfDecryptStageMetricsV2FilterInput>;
  readonly lfEgressStageMetricsV2?: InputMaybe<LfEgressStageMetricsV2FilterInput>;
  readonly lfEncryptStageMetricsV2?: InputMaybe<LfEncryptStageMetricsV2FilterInput>;
  readonly lfIngressStageMetricsV2?: InputMaybe<LfIngressStageMetricsV2FilterInput>;
  readonly lfStripeDecodeStageMetricsV2?: InputMaybe<LfStripeDecodeStageMetricsV2FilterInput>;
  readonly lfStripeDecodeStageMetricsV3?: InputMaybe<LfStripeDecodeStageMetricsV3FilterInput>;
  readonly lfStripeEncodeStageMetricsV2?: InputMaybe<LfStripeEncodeStageMetricsV2FilterInput>;
  readonly lfTimeDecodeStageMetricsV2?: InputMaybe<LfTimeDecodeStageMetricsV2FilterInput>;
  readonly lfTimeDecodeStageMetricsV3?: InputMaybe<LfTimeDecodeStageMetricsV3FilterInput>;
  readonly lfTimeEncodeStageMetricsV2?: InputMaybe<LfTimeEncodeStageMetricsV2FilterInput>;
  readonly lfTracerouteStageMetricsV2?: InputMaybe<LfTracerouteStageMetricsV2FilterInput>;
  readonly lfWanRxStageMetricsV2?: InputMaybe<LfWanRxStageMetricsV2FilterInput>;
  readonly lfWanTxStageMetricsV2?: InputMaybe<LfWanTxStageMetricsV2FilterInput>;
  readonly missionProfileId?: InputMaybe<StringFilterInput>;
  readonly rpm_version?: InputMaybe<StringFilterInput>;
  readonly sourceRegion?: InputMaybe<StringFilterInput>;
  readonly task_id?: InputMaybe<StringFilterInput>;
  readonly timeStampEnd?: InputMaybe<StringFilterInput>;
  readonly timeStampStart?: InputMaybe<StringFilterInput>;
};

export type DataPlaneLfMetricSortInput = {
  readonly agentInformation?: InputMaybe<LaminarFlowAgentMetadataSortInput>;
  readonly agent_id?: InputMaybe<SortOrder>;
  readonly contactStatus?: InputMaybe<SortOrder>;
  readonly contact_id?: InputMaybe<SortOrder>;
  readonly customerId?: InputMaybe<SortOrder>;
  readonly customerNamePart?: InputMaybe<SortOrder>;
  readonly dataflow_id?: InputMaybe<SortOrder>;
  readonly destinationRegion?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly lfDecryptStageMetricsV2?: InputMaybe<LfDecryptStageMetricsV2SortInput>;
  readonly lfEgressStageMetricsV2?: InputMaybe<LfEgressStageMetricsV2SortInput>;
  readonly lfEncryptStageMetricsV2?: InputMaybe<LfEncryptStageMetricsV2SortInput>;
  readonly lfIngressStageMetricsV2?: InputMaybe<LfIngressStageMetricsV2SortInput>;
  readonly lfStripeDecodeStageMetricsV2?: InputMaybe<LfStripeDecodeStageMetricsV2SortInput>;
  readonly lfStripeDecodeStageMetricsV3?: InputMaybe<LfStripeDecodeStageMetricsV3SortInput>;
  readonly lfStripeEncodeStageMetricsV2?: InputMaybe<LfStripeEncodeStageMetricsV2SortInput>;
  readonly lfTimeDecodeStageMetricsV2?: InputMaybe<LfTimeDecodeStageMetricsV2SortInput>;
  readonly lfTimeDecodeStageMetricsV3?: InputMaybe<LfTimeDecodeStageMetricsV3SortInput>;
  readonly lfTimeEncodeStageMetricsV2?: InputMaybe<LfTimeEncodeStageMetricsV2SortInput>;
  readonly lfWanRxStageMetricsV2?: InputMaybe<LfWanRxStageMetricsV2SortInput>;
  readonly lfWanTxStageMetricsV2?: InputMaybe<LfWanTxStageMetricsV2SortInput>;
  readonly missionProfileId?: InputMaybe<SortOrder>;
  readonly rpm_version?: InputMaybe<SortOrder>;
  readonly sourceRegion?: InputMaybe<SortOrder>;
  readonly task_id?: InputMaybe<SortOrder>;
  readonly timeStampEnd?: InputMaybe<SortOrder>;
  readonly timeStampStart?: InputMaybe<SortOrder>;
};

export type DataplaneReport = {
  readonly __typename?: 'DataplaneReport';
  readonly htmlText: Scalars['String']['output'];
};

export type EchoInput = {
  readonly input: Scalars['String']['input'];
};

export type EchoOutput = {
  readonly __typename?: 'EchoOutput';
  readonly output: Scalars['String']['output'];
};

export type FloatFilterInput = {
  readonly _eq?: InputMaybe<Scalars['Float']['input']>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _gt?: InputMaybe<Scalars['Float']['input']>;
  readonly _gte?: InputMaybe<Scalars['Float']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['Float']['input']>>;
  readonly _lt?: InputMaybe<Scalars['Float']['input']>;
  readonly _lte?: InputMaybe<Scalars['Float']['input']>;
  readonly _neq?: InputMaybe<Scalars['Float']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['Float']['input']>>;
};

export type GetDataPlaneDdxMetricInput = {
  readonly jobId?: InputMaybe<Scalars['String']['input']>;
};

export type GetDataPlaneLfMetricInput = {
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type IntegerFilterInput = {
  readonly _eq?: InputMaybe<Scalars['Int']['input']>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _gt?: InputMaybe<Scalars['Int']['input']>;
  readonly _gte?: InputMaybe<Scalars['Int']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
  readonly _lt?: InputMaybe<Scalars['Int']['input']>;
  readonly _lte?: InputMaybe<Scalars['Int']['input']>;
  readonly _neq?: InputMaybe<Scalars['Int']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['Int']['input']>>;
};

export type LaminarFlowAgentMetadata = {
  readonly __typename?: 'LaminarFlowAgentMetadata';
  readonly agentAccountId?: Maybe<Scalars['String']['output']>;
  readonly agentDestinationInstanceId?: Maybe<Scalars['String']['output']>;
  readonly agentInstanceId?: Maybe<Scalars['String']['output']>;
  readonly agentInstanceType?: Maybe<Scalars['String']['output']>;
};

export type LaminarFlowAgentMetadataFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LaminarFlowAgentMetadataFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LaminarFlowAgentMetadataFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LaminarFlowAgentMetadataFilterInput>>;
  readonly agentAccountId?: InputMaybe<StringFilterInput>;
  readonly agentDestinationInstanceId?: InputMaybe<StringFilterInput>;
  readonly agentInstanceId?: InputMaybe<StringFilterInput>;
  readonly agentInstanceType?: InputMaybe<StringFilterInput>;
};

export type LaminarFlowAgentMetadataSortInput = {
  readonly agentAccountId?: InputMaybe<SortOrder>;
  readonly agentDestinationInstanceId?: InputMaybe<SortOrder>;
  readonly agentInstanceId?: InputMaybe<SortOrder>;
  readonly agentInstanceType?: InputMaybe<SortOrder>;
};

export type LaminarFlowLossReportInput = {
  readonly endTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  readonly excludeInternalContacts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly startTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type LaminarFlowLossReportOutput = {
  readonly __typename?: 'LaminarFlowLossReportOutput';
  readonly markdownText: Scalars['String']['output'];
};

export type LaminarFlowMetric = {
  readonly __typename?: 'LaminarFlowMetric';
  readonly avg?: Maybe<Scalars['Float']['output']>;
  readonly max?: Maybe<Scalars['Float']['output']>;
  readonly median?: Maybe<Scalars['Float']['output']>;
  readonly min?: Maybe<Scalars['Float']['output']>;
  readonly p50?: Maybe<Scalars['Float']['output']>;
  readonly p75?: Maybe<Scalars['Float']['output']>;
  readonly p90?: Maybe<Scalars['Float']['output']>;
  readonly p95?: Maybe<Scalars['Float']['output']>;
  readonly p99?: Maybe<Scalars['Float']['output']>;
  readonly stdDev?: Maybe<Scalars['Float']['output']>;
  readonly total?: Maybe<Scalars['Float']['output']>;
};

export type LaminarFlowMetricAggregation = {
  readonly __typename?: 'LaminarFlowMetricAggregation';
  readonly avg: Aggregation;
  readonly max: Aggregation;
  readonly median: Aggregation;
  readonly min: Aggregation;
  readonly p50: Aggregation;
  readonly p75: Aggregation;
  readonly p90: Aggregation;
  readonly p95: Aggregation;
  readonly p99: Aggregation;
  readonly stdDev: Aggregation;
  readonly total: Aggregation;
};

export type LaminarFlowMetricFilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LaminarFlowMetricFilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LaminarFlowMetricFilterInput>>;
  readonly avg?: InputMaybe<FloatFilterInput>;
  readonly max?: InputMaybe<FloatFilterInput>;
  readonly median?: InputMaybe<FloatFilterInput>;
  readonly min?: InputMaybe<FloatFilterInput>;
  readonly p50?: InputMaybe<FloatFilterInput>;
  readonly p75?: InputMaybe<FloatFilterInput>;
  readonly p90?: InputMaybe<FloatFilterInput>;
  readonly p95?: InputMaybe<FloatFilterInput>;
  readonly p99?: InputMaybe<FloatFilterInput>;
  readonly stdDev?: InputMaybe<FloatFilterInput>;
  readonly total?: InputMaybe<FloatFilterInput>;
};

export type LaminarFlowMetricSortInput = {
  readonly avg?: InputMaybe<SortOrder>;
  readonly max?: InputMaybe<SortOrder>;
  readonly median?: InputMaybe<SortOrder>;
  readonly min?: InputMaybe<SortOrder>;
  readonly p50?: InputMaybe<SortOrder>;
  readonly p75?: InputMaybe<SortOrder>;
  readonly p90?: InputMaybe<SortOrder>;
  readonly p95?: InputMaybe<SortOrder>;
  readonly p99?: InputMaybe<SortOrder>;
  readonly stdDev?: InputMaybe<SortOrder>;
  readonly total?: InputMaybe<SortOrder>;
};

export type LaminarFlowPlot = {
  readonly __typename?: 'LaminarFlowPlot';
  readonly agentId?: Maybe<Scalars['String']['output']>;
  readonly dataflowId?: Maybe<Scalars['String']['output']>;
  readonly imageBase64?: Maybe<Scalars['String']['output']>;
  readonly plotName?: Maybe<Scalars['String']['output']>;
  readonly presignedGetUrl?: Maybe<Scalars['String']['output']>;
  readonly s3Key: Scalars['String']['output'];
};

export type LfDecryptStageMetricsV2 = {
  readonly __typename?: 'LfDecryptStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decryption_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__input_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__output_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: Maybe<LaminarFlowMetric>;
  readonly metric__total_decryption_errors?: Maybe<LaminarFlowMetric>;
};

export type LfDecryptStageMetricsV2Aggregation = {
  readonly __typename?: 'LfDecryptStageMetricsV2Aggregation';
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__decryption_error_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__input_queue_underflow_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__total_input_queue_underflows: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__input_message_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__output_message_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__output_queue_overflow_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__total_output_queue_overflows: LaminarFlowMetricAggregation;
  readonly metric__total_decryption_errors: LaminarFlowMetricAggregation;
};

export type LfDecryptStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfDecryptStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfDecryptStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfDecryptStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decryption_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_decryption_errors?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfDecryptStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decryption_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_decryption_errors?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfEgressStageMetricsV2 = {
  readonly __typename?: 'LfEgressStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__average_bytes_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__average_datagrams_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__average_max_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__average_min_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__average_width_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__connection_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__connection_refused_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__initial_input_sequence_count?: Maybe<LaminarFlowMetric>;
  readonly metric__input_bit_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: Maybe<LaminarFlowMetric>;
  readonly metric__last_input_sequence_count?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__input_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__output_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__network_unreachable_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_bit_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__overall_timestamp_delta_sec_max?: Maybe<LaminarFlowMetric>;
  readonly metric__overall_timestamp_delta_sec_min?: Maybe<LaminarFlowMetric>;
  readonly metric__packets_lost_sequence_count?: Maybe<LaminarFlowMetric>;
  readonly metric__packets_out_of_order_sequence_count?: Maybe<LaminarFlowMetric>;
  readonly metric__socket_overflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__timestamp_delta_sec_max?: Maybe<LaminarFlowMetric>;
  readonly metric__timestamp_delta_sec_min?: Maybe<LaminarFlowMetric>;
  readonly metric__total_input_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__total_output_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__total_packets_lost_sequence_count?: Maybe<LaminarFlowMetric>;
  readonly metric__total_packets_out_of_order_sequence_count?: Maybe<LaminarFlowMetric>;
  readonly metric__total_retransmitted_messages?: Maybe<LaminarFlowMetric>;
  readonly metric__total_socket_overflows?: Maybe<LaminarFlowMetric>;
};

export type LfEgressStageMetricsV2Aggregation = {
  readonly __typename?: 'LfEgressStageMetricsV2Aggregation';
  readonly metric__average_bytes_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__average_datagrams_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__average_max_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__average_min_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__average_width_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__connection_error_rate: LaminarFlowMetricAggregation;
  readonly metric__connection_refused_error_rate: LaminarFlowMetricAggregation;
  readonly metric__initial_input_sequence_count: LaminarFlowMetricAggregation;
  readonly metric__input_bit_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__input_queue_underflow_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__total_input_queue_underflows: LaminarFlowMetricAggregation;
  readonly metric__last_input_sequence_count: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__input_message_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__output_message_rate: LaminarFlowMetricAggregation;
  readonly metric__network_unreachable_error_rate: LaminarFlowMetricAggregation;
  readonly metric__output_bit_rate: LaminarFlowMetricAggregation;
  readonly metric__overall_timestamp_delta_sec_max: LaminarFlowMetricAggregation;
  readonly metric__overall_timestamp_delta_sec_min: LaminarFlowMetricAggregation;
  readonly metric__packets_lost_sequence_count: LaminarFlowMetricAggregation;
  readonly metric__packets_out_of_order_sequence_count: LaminarFlowMetricAggregation;
  readonly metric__socket_overflow_rate: LaminarFlowMetricAggregation;
  readonly metric__timestamp_delta_sec_max: LaminarFlowMetricAggregation;
  readonly metric__timestamp_delta_sec_min: LaminarFlowMetricAggregation;
  readonly metric__total_input_bytes: LaminarFlowMetricAggregation;
  readonly metric__total_output_bytes: LaminarFlowMetricAggregation;
  readonly metric__total_packets_lost_sequence_count: LaminarFlowMetricAggregation;
  readonly metric__total_packets_out_of_order_sequence_count: LaminarFlowMetricAggregation;
  readonly metric__total_retransmitted_messages: LaminarFlowMetricAggregation;
  readonly metric__total_socket_overflows: LaminarFlowMetricAggregation;
};

export type LfEgressStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfEgressStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfEgressStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfEgressStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__average_bytes_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__average_datagrams_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__average_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__average_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__average_width_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__connection_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__connection_refused_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__initial_input_sequence_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_bit_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__last_input_sequence_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__network_unreachable_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_bit_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__overall_timestamp_delta_sec_max?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__overall_timestamp_delta_sec_min?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__packets_lost_sequence_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__packets_out_of_order_sequence_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__socket_overflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__timestamp_delta_sec_max?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__timestamp_delta_sec_min?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_input_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_output_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_packets_lost_sequence_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_packets_out_of_order_sequence_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_retransmitted_messages?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_socket_overflows?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfEgressStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__average_bytes_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__average_datagrams_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__average_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__average_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__average_width_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__connection_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__connection_refused_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__initial_input_sequence_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_bit_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__last_input_sequence_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__network_unreachable_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_bit_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__overall_timestamp_delta_sec_max?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__overall_timestamp_delta_sec_min?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__packets_lost_sequence_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__packets_out_of_order_sequence_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__socket_overflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__timestamp_delta_sec_max?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__timestamp_delta_sec_min?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_input_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_output_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_packets_lost_sequence_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_packets_out_of_order_sequence_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_retransmitted_messages?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_socket_overflows?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfEncryptStageMetricsV2 = {
  readonly __typename?: 'LfEncryptStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__encryption_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__input_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__output_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: Maybe<LaminarFlowMetric>;
  readonly metric__total_encryption_errors?: Maybe<LaminarFlowMetric>;
};

export type LfEncryptStageMetricsV2Aggregation = {
  readonly __typename?: 'LfEncryptStageMetricsV2Aggregation';
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__encryption_error_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__input_queue_underflow_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__total_input_queue_underflows: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__input_message_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__output_message_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__output_queue_overflow_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__total_output_queue_overflows: LaminarFlowMetricAggregation;
  readonly metric__total_encryption_errors: LaminarFlowMetricAggregation;
};

export type LfEncryptStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfEncryptStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfEncryptStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfEncryptStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__encryption_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_encryption_errors?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfEncryptStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__encryption_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_encryption_errors?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfIngressStageMetricsV2 = {
  readonly __typename?: 'LfIngressStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_bit_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_drop_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: Maybe<LaminarFlowMetric>;
  readonly metric__last_output_sequence_count?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__input_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__output_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_bit_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: Maybe<LaminarFlowMetric>;
  readonly metric__socket_back_off_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__socket_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__total_early_input_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__total_input_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__total_input_drops?: Maybe<LaminarFlowMetric>;
  readonly metric__total_late_input_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__total_output_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__total_socket_back_offs?: Maybe<LaminarFlowMetric>;
  readonly metric__total_socket_errors?: Maybe<LaminarFlowMetric>;
  readonly metric__total_timely_input_bytes?: Maybe<LaminarFlowMetric>;
};

export type LfIngressStageMetricsV2Aggregation = {
  readonly __typename?: 'LfIngressStageMetricsV2Aggregation';
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__input_bit_rate: LaminarFlowMetricAggregation;
  readonly metric__input_drop_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__input_queue_underflow_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__total_input_queue_underflows: LaminarFlowMetricAggregation;
  readonly metric__last_output_sequence_count: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__input_message_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__output_message_rate: LaminarFlowMetricAggregation;
  readonly metric__output_bit_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__output_queue_overflow_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__total_output_queue_overflows: LaminarFlowMetricAggregation;
  readonly metric__socket_back_off_rate: LaminarFlowMetricAggregation;
  readonly metric__socket_error_rate: LaminarFlowMetricAggregation;
  readonly metric__total_early_input_bytes: LaminarFlowMetricAggregation;
  readonly metric__total_input_bytes: LaminarFlowMetricAggregation;
  readonly metric__total_input_drops: LaminarFlowMetricAggregation;
  readonly metric__total_late_input_bytes: LaminarFlowMetricAggregation;
  readonly metric__total_output_bytes: LaminarFlowMetricAggregation;
  readonly metric__total_socket_back_offs: LaminarFlowMetricAggregation;
  readonly metric__total_socket_errors: LaminarFlowMetricAggregation;
  readonly metric__total_timely_input_bytes: LaminarFlowMetricAggregation;
};

export type LfIngressStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfIngressStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfIngressStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfIngressStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_bit_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_drop_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__last_output_sequence_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_bit_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__socket_back_off_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__socket_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_early_input_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_input_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_input_drops?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_late_input_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_output_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_socket_back_offs?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_socket_errors?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__total_timely_input_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfIngressStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_bit_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_drop_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__last_output_sequence_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_bit_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__socket_back_off_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__socket_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_early_input_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_input_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_input_drops?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_late_input_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_output_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_socket_back_offs?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_socket_errors?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__total_timely_input_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfStripeDecodeStageMetricsV2 = {
  readonly __typename?: 'LfStripeDecodeStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_block_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_missing_history?: Maybe<ReadonlyArray<Scalars['Float']['output']>>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__head_block_set_number?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: Maybe<LaminarFlowMetric>;
  readonly metric__last_processed_stripe_index?: Maybe<LaminarFlowMetric>;
  readonly metric__output_block_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: Maybe<LaminarFlowMetric>;
  readonly metric__tail_block_set_number?: Maybe<LaminarFlowMetric>;
};

export type LfStripeDecodeStageMetricsV2Aggregation = {
  readonly __typename?: 'LfStripeDecodeStageMetricsV2Aggregation';
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_block_error_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_block_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_duplicated: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_missing: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_orphaned: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_recovered: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_stale: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate: LaminarFlowMetricAggregation;
  readonly metric__head_block_set_number: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__input_queue_underflow_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__total_input_queue_underflows: LaminarFlowMetricAggregation;
  readonly metric__last_processed_stripe_index: LaminarFlowMetricAggregation;
  readonly metric__output_block_error_rate: LaminarFlowMetricAggregation;
  readonly metric__output_message_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__output_queue_overflow_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__total_output_queue_overflows: LaminarFlowMetricAggregation;
  readonly metric__tail_block_set_number: LaminarFlowMetricAggregation;
};

export type LfStripeDecodeStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfStripeDecodeStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfStripeDecodeStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfStripeDecodeStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_block_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing_history?: InputMaybe<FloatFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__head_block_set_number?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__last_processed_stripe_index?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_block_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__tail_block_set_number?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfStripeDecodeStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_block_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__head_block_set_number?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__last_processed_stripe_index?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_block_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__tail_block_set_number?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfStripeDecodeStageMetricsV3 = {
  readonly __typename?: 'LfStripeDecodeStageMetricsV3';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_block_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_missing_history?: Maybe<ReadonlyArray<Scalars['Float']['output']>>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__head_block_set_number?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: Maybe<LaminarFlowMetric>;
  readonly metric__last_processed_stripe_index?: Maybe<LaminarFlowMetric>;
  readonly metric__output_block_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: Maybe<LaminarFlowMetric>;
  readonly metric__tail_block_set_number?: Maybe<LaminarFlowMetric>;
};

export type LfStripeDecodeStageMetricsV3Aggregation = {
  readonly __typename?: 'LfStripeDecodeStageMetricsV3Aggregation';
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_block_error_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_block_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_duplicated: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_missing: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_orphaned: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_recovered: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_stale: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate: LaminarFlowMetricAggregation;
  readonly metric__head_block_set_number: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__input_queue_underflow_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__total_input_queue_underflows: LaminarFlowMetricAggregation;
  readonly metric__last_processed_stripe_index: LaminarFlowMetricAggregation;
  readonly metric__output_block_error_rate: LaminarFlowMetricAggregation;
  readonly metric__output_message_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__output_queue_overflow_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__total_output_queue_overflows: LaminarFlowMetricAggregation;
  readonly metric__tail_block_set_number: LaminarFlowMetricAggregation;
};

export type LfStripeDecodeStageMetricsV3FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfStripeDecodeStageMetricsV3FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfStripeDecodeStageMetricsV3FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfStripeDecodeStageMetricsV3FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_block_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing_history?: InputMaybe<FloatFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__head_block_set_number?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__last_processed_stripe_index?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_block_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__tail_block_set_number?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfStripeDecodeStageMetricsV3SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_block_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__head_block_set_number?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__last_processed_stripe_index?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_block_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__tail_block_set_number?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfStripeEncodeStageMetricsV2 = {
  readonly __typename?: 'LfStripeEncodeStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__input_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__output_message_rate?: Maybe<LaminarFlowMetric>;
};

export type LfStripeEncodeStageMetricsV2Aggregation = {
  readonly __typename?: 'LfStripeEncodeStageMetricsV2Aggregation';
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__input_message_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__output_message_rate: LaminarFlowMetricAggregation;
};

export type LfStripeEncodeStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfStripeEncodeStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfStripeEncodeStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfStripeEncodeStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfStripeEncodeStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfTimeDecodeStageMetricsV2 = {
  readonly __typename?: 'LfTimeDecodeStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_block_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_missing_history?: Maybe<ReadonlyArray<Scalars['Float']['output']>>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: Maybe<LaminarFlowMetric>;
  readonly metric__output_block_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: Maybe<LaminarFlowMetric>;
};

export type LfTimeDecodeStageMetricsV2Aggregation = {
  readonly __typename?: 'LfTimeDecodeStageMetricsV2Aggregation';
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_block_error_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_block_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_duplicated: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_missing: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_orphaned: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_recovered: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_stale: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__input_queue_underflow_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__total_input_queue_underflows: LaminarFlowMetricAggregation;
  readonly metric__output_block_error_rate: LaminarFlowMetricAggregation;
  readonly metric__output_message_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__output_queue_overflow_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__total_output_queue_overflows: LaminarFlowMetricAggregation;
};

export type LfTimeDecodeStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfTimeDecodeStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfTimeDecodeStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfTimeDecodeStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_block_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing_history?: InputMaybe<FloatFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_block_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfTimeDecodeStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_block_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_block_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfTimeDecodeStageMetricsV3 = {
  readonly __typename?: 'LfTimeDecodeStageMetricsV3';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_block_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_missing_history?: Maybe<ReadonlyArray<Scalars['Float']['output']>>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: Maybe<LaminarFlowMetric>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: Maybe<LaminarFlowMetric>;
  readonly metric__output_block_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: Maybe<LaminarFlowMetric>;
};

export type LfTimeDecodeStageMetricsV3Aggregation = {
  readonly __typename?: 'LfTimeDecodeStageMetricsV3Aggregation';
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_block_error_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_block_rate: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_duplicated: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_missing: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_orphaned: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_recovered: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_stale: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable: LaminarFlowMetricAggregation;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__input_queue_underflow_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__total_input_queue_underflows: LaminarFlowMetricAggregation;
  readonly metric__output_block_error_rate: LaminarFlowMetricAggregation;
  readonly metric__output_message_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__output_queue_overflow_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__total_output_queue_overflows: LaminarFlowMetricAggregation;
};

export type LfTimeDecodeStageMetricsV3FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfTimeDecodeStageMetricsV3FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfTimeDecodeStageMetricsV3FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfTimeDecodeStageMetricsV3FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_block_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing_history?: InputMaybe<FloatFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_block_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfTimeDecodeStageMetricsV3SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_block_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_block_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_duplicated?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_missing?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_orphaned?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_out_of_order?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_recovered?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_stale?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_blocks_unrecoverable?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__decoding_input_metrics__input_virtual_fill_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_block_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfTimeEncodeStageMetricsV2 = {
  readonly __typename?: 'LfTimeEncodeStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__input_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__output_message_rate?: Maybe<LaminarFlowMetric>;
};

export type LfTimeEncodeStageMetricsV2Aggregation = {
  readonly __typename?: 'LfTimeEncodeStageMetricsV2Aggregation';
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__input_message_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__output_message_rate: LaminarFlowMetricAggregation;
};

export type LfTimeEncodeStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfTimeEncodeStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfTimeEncodeStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfTimeEncodeStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfTimeEncodeStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfTracerouteStageMetricsV2 = {
  readonly __typename?: 'LfTracerouteStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__dest?: Maybe<Scalars['String']['output']>;
  readonly metric__hop_count?: Maybe<Scalars['Int']['output']>;
  readonly metric__hops__addr?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly metric__hops__est_rtt?: Maybe<ReadonlyArray<Scalars['Float']['output']>>;
  readonly metric__hops__ttl?: Maybe<ReadonlyArray<Scalars['Float']['output']>>;
  readonly metric__id?: Maybe<Scalars['String']['output']>;
  readonly metric__source?: Maybe<Scalars['String']['output']>;
  readonly metric__status?: Maybe<Scalars['String']['output']>;
  readonly timestamp?: Maybe<Scalars['String']['output']>;
};

export type LfTracerouteStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfTracerouteStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfTracerouteStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfTracerouteStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__dest?: InputMaybe<StringFilterInput>;
  readonly metric__hop_count?: InputMaybe<IntegerFilterInput>;
  readonly metric__hops__addr?: InputMaybe<StringFilterInput>;
  readonly metric__hops__est_rtt?: InputMaybe<FloatFilterInput>;
  readonly metric__hops__ttl?: InputMaybe<FloatFilterInput>;
  readonly metric__id?: InputMaybe<StringFilterInput>;
  readonly metric__source?: InputMaybe<StringFilterInput>;
  readonly metric__status?: InputMaybe<StringFilterInput>;
  readonly timestamp?: InputMaybe<StringFilterInput>;
};

export type LfWanRxStageMetricsV2 = {
  readonly __typename?: 'LfWanRxStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__bytes_metrics__input_bit_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__bytes_metrics__output_bit_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__bytes_metrics__total_input_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__bytes_metrics__total_output_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__selected_lessor?: Maybe<Scalars['String']['output']>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__received_heartbeat_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__selected_lessee?: Maybe<Scalars['String']['output']>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__transmitted_heartbeat_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__transmitted_lease_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_success_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__input_control_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__output_control_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_input_control_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_output_control_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__input_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__output_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: Maybe<LaminarFlowMetric>;
};

export type LfWanRxStageMetricsV2Aggregation = {
  readonly __typename?: 'LfWanRxStageMetricsV2Aggregation';
  readonly metric__bytes_metrics__input_bit_rate: LaminarFlowMetricAggregation;
  readonly metric__bytes_metrics__output_bit_rate: LaminarFlowMetricAggregation;
  readonly metric__bytes_metrics__total_input_bytes: LaminarFlowMetricAggregation;
  readonly metric__bytes_metrics__total_output_bytes: LaminarFlowMetricAggregation;
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__received_heartbeat_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__transmitted_heartbeat_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__transmitted_lease_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_error_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_success_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__input_control_message_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__output_control_message_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_input_control_message_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_output_control_message_rate: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_error_count: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_rate: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_error_count: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_rate: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_error_count: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_rate: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_error_count: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__input_message_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__output_message_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__output_queue_overflow_rate: LaminarFlowMetricAggregation;
  readonly metric__output_queue_metrics__total_output_queue_overflows: LaminarFlowMetricAggregation;
};

export type LfWanRxStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfWanRxStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfWanRxStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfWanRxStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__bytes_metrics__input_bit_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__bytes_metrics__output_bit_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__bytes_metrics__total_input_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__bytes_metrics__total_output_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__selected_lessor?: InputMaybe<StringFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__received_heartbeat_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__selected_lessee?: InputMaybe<StringFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__transmitted_heartbeat_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__transmitted_lease_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_success_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__input_control_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__output_control_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_input_control_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_output_control_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfWanRxStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__bytes_metrics__input_bit_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__bytes_metrics__output_bit_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__bytes_metrics__total_input_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__bytes_metrics__total_output_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__selected_lessor?: InputMaybe<SortOrder>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__received_heartbeat_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__selected_lessee?: InputMaybe<SortOrder>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__transmitted_heartbeat_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__transmitted_lease_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_success_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__input_control_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__output_control_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_input_control_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_output_control_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__output_queue_overflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__output_queue_metrics__total_output_queue_overflows?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type LfWanTxStageMetricsV2 = {
  readonly __typename?: 'LfWanTxStageMetricsV2';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly metric__bytes_metrics__input_bit_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__bytes_metrics__output_bit_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__bytes_metrics__total_input_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__bytes_metrics__total_output_bytes?: Maybe<LaminarFlowMetric>;
  readonly metric__common_stage_metrics__tick_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__received_heartbeat_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__received_lease_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__selected_lessor?: Maybe<Scalars['String']['output']>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__transmitted_heartbeat_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__selected_lessee?: Maybe<Scalars['String']['output']>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_error_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_success_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__input_control_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__output_control_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_input_control_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_output_control_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: Maybe<LaminarFlowMetric>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: Maybe<LaminarFlowMetric>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__dropped_message_count?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__input_message_rate?: Maybe<LaminarFlowMetric>;
  readonly metric__message_metrics__output_message_rate?: Maybe<LaminarFlowMetric>;
};

export type LfWanTxStageMetricsV2Aggregation = {
  readonly __typename?: 'LfWanTxStageMetricsV2Aggregation';
  readonly metric__bytes_metrics__input_bit_rate: LaminarFlowMetricAggregation;
  readonly metric__bytes_metrics__output_bit_rate: LaminarFlowMetricAggregation;
  readonly metric__bytes_metrics__total_input_bytes: LaminarFlowMetricAggregation;
  readonly metric__bytes_metrics__total_output_bytes: LaminarFlowMetricAggregation;
  readonly metric__common_stage_metrics__tick_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__received_heartbeat_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__received_lease_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__transmitted_heartbeat_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_error_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_success_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__input_control_message_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__output_control_message_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_input_control_message_rate: LaminarFlowMetricAggregation;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_output_control_message_rate: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_error_count: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_rate: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_error_count: LaminarFlowMetricAggregation;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_rate: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_error_count: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_rate: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_error_count: LaminarFlowMetricAggregation;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_rate: LaminarFlowMetricAggregation;
  readonly metric__dropped_message_count: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__input_queue_underflow_rate: LaminarFlowMetricAggregation;
  readonly metric__input_queue_metrics__total_input_queue_underflows: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__input_message_rate: LaminarFlowMetricAggregation;
  readonly metric__message_metrics__output_message_rate: LaminarFlowMetricAggregation;
};

export type LfWanTxStageMetricsV2FilterInput = {
  readonly _and?: InputMaybe<ReadonlyArray<LfWanTxStageMetricsV2FilterInput>>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _not?: InputMaybe<LfWanTxStageMetricsV2FilterInput>;
  readonly _or?: InputMaybe<ReadonlyArray<LfWanTxStageMetricsV2FilterInput>>;
  readonly id?: InputMaybe<StringFilterInput>;
  readonly metric__bytes_metrics__input_bit_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__bytes_metrics__output_bit_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__bytes_metrics__total_input_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__bytes_metrics__total_output_bytes?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__received_heartbeat_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__received_lease_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__selected_lessor?: InputMaybe<StringFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__transmitted_heartbeat_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__selected_lessee?: InputMaybe<StringFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_error_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_success_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__input_control_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__output_control_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_input_control_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_output_control_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__dropped_message_count?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricFilterInput>;
};

export type LfWanTxStageMetricsV2SortInput = {
  readonly id?: InputMaybe<SortOrder>;
  readonly metric__bytes_metrics__input_bit_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__bytes_metrics__output_bit_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__bytes_metrics__total_input_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__bytes_metrics__total_output_bytes?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__common_stage_metrics__tick_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__received_heartbeat_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__received_lease_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__selected_lessor?: InputMaybe<SortOrder>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessee_metrics__transmitted_heartbeat_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_handlers_metrics__transmit_lessor_metrics__selected_lessee?: InputMaybe<SortOrder>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_error_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__decryption_success_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__input_control_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__output_control_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_input_control_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_message_manager_metrics__control_message_metrics__unsupported_output_control_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__control_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__recvmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_datagram_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_max_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_min_depth_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_segment_count_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__mean_width_per_syscall?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__eagain?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__econnrefused?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__ehostunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__enetunreach?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__socket_error_counts__other?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_error_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__data_plane_socket_metrics__sendmmsg_metrics__syscall_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__dropped_message_count?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__input_queue_underflow_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__input_queue_metrics__total_input_queue_underflows?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__input_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
  readonly metric__message_metrics__output_message_rate?: InputMaybe<LaminarFlowMetricSortInput>;
};

export type ListDataPlaneDdxMetricInput = {
  readonly cursor?: InputMaybe<ReadonlyArray<CursorPartInput>>;
  readonly limit?: InputMaybe<Scalars['Int']['input']>;
  readonly sort?: InputMaybe<ReadonlyArray<DataPlaneDdxMetricSortInput>>;
  readonly where?: InputMaybe<DataPlaneDdxMetricFilterInput>;
};

export type ListDataPlaneDdxMetricOutput = {
  readonly __typename?: 'ListDataPlaneDDXMetricOutput';
  readonly pageInfo: PageInfo;
  readonly results: ReadonlyArray<DataPlaneDdxMetric>;
};

export type ListDataPlaneLfMetricInput = {
  readonly cursor?: InputMaybe<ReadonlyArray<CursorPartInput>>;
  readonly limit?: InputMaybe<Scalars['Int']['input']>;
  readonly sort?: InputMaybe<ReadonlyArray<DataPlaneLfMetricSortInput>>;
  readonly where?: InputMaybe<DataPlaneLfMetricFilterInput>;
};

export type ListDataPlaneLfMetricOutput = {
  readonly __typename?: 'ListDataPlaneLFMetricOutput';
  readonly aggregations: DataPlaneLfMetricAggregation;
  readonly pageInfo: PageInfo;
  readonly results: ReadonlyArray<DataPlaneLfMetric>;
};

export type PageInfo = {
  readonly __typename?: 'PageInfo';
  readonly hasNextPage: Scalars['Boolean']['output'];
  readonly lastCursor?: Maybe<ReadonlyArray<CursorPart>>;
  readonly total: Total;
};

export type PostPassImage = {
  readonly __typename?: 'PostPassImage';
  readonly dataflowId?: Maybe<Scalars['String']['output']>;
  readonly imageBase64?: Maybe<Scalars['String']['output']>;
  readonly jobId?: Maybe<Scalars['String']['output']>;
  readonly presignedGetUrl?: Maybe<Scalars['String']['output']>;
  readonly s3Key: Scalars['String']['output'];
};

export type PresignedDeviceDetail = {
  readonly __typename?: 'PresignedDeviceDetail';
  readonly url?: Maybe<Scalars['String']['output']>;
};

export type PresignedS3Metric = {
  readonly __typename?: 'PresignedS3Metric';
  readonly agentId?: Maybe<Scalars['String']['output']>;
  readonly dataflowId?: Maybe<Scalars['String']['output']>;
  readonly taskId?: Maybe<Scalars['String']['output']>;
  readonly url?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  readonly __typename?: 'Query';
  readonly echo?: Maybe<EchoOutput>;
  readonly getContactById?: Maybe<Contact>;
  readonly getDataPlaneDDXMetric?: Maybe<DataPlaneDdxMetric>;
  readonly getDataPlaneLFMetric?: Maybe<DataPlaneLfMetric>;
  readonly getLaminarFlowLossReport?: Maybe<LaminarFlowLossReportOutput>;
  readonly listDataPlaneDDXMetric?: Maybe<ListDataPlaneDdxMetricOutput>;
  readonly listDataPlaneLFMetric?: Maybe<ListDataPlaneLfMetricOutput>;
};


export type QueryEchoArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: EchoInput;
};


export type QueryGetContactByIdArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: ContactByIdInput;
};


export type QueryGetDataPlaneDdxMetricArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: GetDataPlaneDdxMetricInput;
};


export type QueryGetDataPlaneLfMetricArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: GetDataPlaneLfMetricInput;
};


export type QueryGetLaminarFlowLossReportArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: LaminarFlowLossReportInput;
};


export type QueryListDataPlaneDdxMetricArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: ListDataPlaneDdxMetricInput;
};


export type QueryListDataPlaneLfMetricArgs = {
  cazJustification?: InputMaybe<Scalars['String']['input']>;
  input: ListDataPlaneLfMetricInput;
};

export enum Relation {
  Eq = 'eq',
  Gte = 'gte'
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type StringFilterInput = {
  readonly _eq?: InputMaybe<Scalars['String']['input']>;
  readonly _exists?: InputMaybe<Scalars['Boolean']['input']>;
  readonly _gt?: InputMaybe<Scalars['String']['input']>;
  readonly _gte?: InputMaybe<Scalars['String']['input']>;
  readonly _in?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly _lt?: InputMaybe<Scalars['String']['input']>;
  readonly _lte?: InputMaybe<Scalars['String']['input']>;
  readonly _neq?: InputMaybe<Scalars['String']['input']>;
  readonly _nin?: InputMaybe<ReadonlyArray<Scalars['String']['input']>>;
  readonly _startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Total = {
  readonly __typename?: 'Total';
  readonly relation?: Maybe<Relation>;
  readonly value?: Maybe<Scalars['Int']['output']>;
};

export type TracerouteDetails = {
  readonly __typename?: 'TracerouteDetails';
  readonly deviceDetails?: Maybe<ReadonlyArray<PresignedDeviceDetail>>;
  readonly egressStageLossPresignedS3Url?: Maybe<ReadonlyArray<PresignedS3Metric>>;
  readonly rawTracerouteMetricsPresignedS3Url?: Maybe<ReadonlyArray<PresignedS3Metric>>;
  readonly timeDecodeLoss?: Maybe<ReadonlyArray<PresignedS3Metric>>;
};

export type AgentDataProductContactReportsQueryVariables = Exact<{
  input: ContactByIdInput;
}>;


export type AgentDataProductContactReportsQuery = { readonly __typename?: 'Query', readonly getContactById?: { readonly __typename?: 'Contact', readonly id: string, readonly agentPostPassReports?: ReadonlyArray<{ readonly __typename?: 'AgentPostPassReport', readonly agentId: string, readonly taskDocumentId: string, readonly s3Key: string, readonly markdownText: string }> | null, readonly dataplaneReport?: { readonly __typename?: 'DataplaneReport', readonly htmlText: string } | null } | null };

export type CpsImagesQueryVariables = Exact<{
  input: ContactByIdInput;
}>;


export type CpsImagesQuery = { readonly __typename?: 'Query', readonly getContactById?: { readonly __typename?: 'Contact', readonly id: string, readonly images?: ReadonlyArray<{ readonly __typename?: 'PostPassImage', readonly dataflowId?: string | null, readonly s3Key: string, readonly jobId?: string | null, readonly presignedGetUrl?: string | null }> | null, readonly laminarFlowPlots?: ReadonlyArray<{ readonly __typename?: 'LaminarFlowPlot', readonly agentId?: string | null, readonly dataflowId?: string | null, readonly presignedGetUrl?: string | null, readonly plotName?: string | null, readonly s3Key: string }> | null } | null };

export type DataplaneVisualizationQueryVariables = Exact<{
  input: ContactByIdInput;
}>;


export type DataplaneVisualizationQuery = { readonly __typename?: 'Query', readonly getContactById?: { readonly __typename?: 'Contact', readonly id: string, readonly visualization?: { readonly __typename?: 'ContactVisualization', readonly dataplaneSvgUrlDark?: string | null, readonly dataplaneSvgUrlLight?: string | null, readonly s3Key?: string | null } | null } | null };

export type DdxMetricsResultFragment = { readonly __typename?: 'DataPlaneDDXMetric', readonly endTime: string, readonly contactId: string, readonly region: string, readonly startTime: string, readonly jobId: string, readonly streamMetrics: ReadonlyArray<{ readonly __typename?: 'DDXStreamMetric', readonly wanPacketsLost?: number | null, readonly wanPacketsReordered?: number | null, readonly wanPacketsRepaired?: number | null, readonly dataLatency?: { readonly __typename?: 'DDXStatistic', readonly avg?: number | null, readonly p99?: number | null, readonly p95?: number | null, readonly p50?: number | null } | null, readonly wanLatency?: { readonly __typename?: 'DDXStatistic', readonly avg?: number | null, readonly p99?: number | null, readonly p95?: number | null, readonly p50?: number | null } | null, readonly wanRtt?: { readonly __typename?: 'DDXStatistic', readonly avg?: number | null, readonly p99?: number | null, readonly p95?: number | null, readonly p50?: number | null } | null }> };

export type ListDdxMetricsQueryVariables = Exact<{
  where: DataPlaneDdxMetricFilterInput;
  cursor?: InputMaybe<ReadonlyArray<CursorPartInput> | CursorPartInput>;
  sort?: InputMaybe<ReadonlyArray<DataPlaneDdxMetricSortInput> | DataPlaneDdxMetricSortInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListDdxMetricsQuery = { readonly __typename?: 'Query', readonly listDataPlaneDDXMetric?: { readonly __typename?: 'ListDataPlaneDDXMetricOutput', readonly results: ReadonlyArray<{ readonly __typename?: 'DataPlaneDDXMetric', readonly endTime: string, readonly contactId: string, readonly region: string, readonly startTime: string, readonly jobId: string, readonly streamMetrics: ReadonlyArray<{ readonly __typename?: 'DDXStreamMetric', readonly wanPacketsLost?: number | null, readonly wanPacketsReordered?: number | null, readonly wanPacketsRepaired?: number | null, readonly dataLatency?: { readonly __typename?: 'DDXStatistic', readonly avg?: number | null, readonly p99?: number | null, readonly p95?: number | null, readonly p50?: number | null } | null, readonly wanLatency?: { readonly __typename?: 'DDXStatistic', readonly avg?: number | null, readonly p99?: number | null, readonly p95?: number | null, readonly p50?: number | null } | null, readonly wanRtt?: { readonly __typename?: 'DDXStatistic', readonly avg?: number | null, readonly p99?: number | null, readonly p95?: number | null, readonly p50?: number | null } | null }> }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly relation?: Relation | null, readonly value?: number | null } } } | null };

export type LfMetricsResultFragment = { readonly __typename?: 'DataPlaneLFMetric', readonly id: string, readonly contact_id: string, readonly timeStampStart?: string | null, readonly timeStampEnd?: string | null, readonly sourceRegion?: string | null, readonly destinationRegion?: string | null, readonly lfEgressStageMetricsV2?: { readonly __typename?: 'LfEgressStageMetricsV2', readonly metric__packets_lost_sequence_count?: { readonly __typename?: 'LaminarFlowMetric', readonly max?: number | null, readonly total?: number | null } | null, readonly metric__last_input_sequence_count?: { readonly __typename?: 'LaminarFlowMetric', readonly max?: number | null, readonly total?: number | null } | null, readonly metric__timestamp_delta_sec_min?: { readonly __typename?: 'LaminarFlowMetric', readonly avg?: number | null } | null, readonly metric__timestamp_delta_sec_max?: { readonly __typename?: 'LaminarFlowMetric', readonly avg?: number | null } | null } | null };

export type ListLfMetricsQueryVariables = Exact<{
  where: DataPlaneLfMetricFilterInput;
  cursor?: InputMaybe<ReadonlyArray<CursorPartInput> | CursorPartInput>;
  sort?: InputMaybe<ReadonlyArray<DataPlaneLfMetricSortInput> | DataPlaneLfMetricSortInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListLfMetricsQuery = { readonly __typename?: 'Query', readonly listDataPlaneLFMetric?: { readonly __typename?: 'ListDataPlaneLFMetricOutput', readonly results: ReadonlyArray<{ readonly __typename?: 'DataPlaneLFMetric', readonly id: string, readonly contact_id: string, readonly timeStampStart?: string | null, readonly timeStampEnd?: string | null, readonly sourceRegion?: string | null, readonly destinationRegion?: string | null, readonly lfEgressStageMetricsV2?: { readonly __typename?: 'LfEgressStageMetricsV2', readonly metric__packets_lost_sequence_count?: { readonly __typename?: 'LaminarFlowMetric', readonly max?: number | null, readonly total?: number | null } | null, readonly metric__last_input_sequence_count?: { readonly __typename?: 'LaminarFlowMetric', readonly max?: number | null, readonly total?: number | null } | null, readonly metric__timestamp_delta_sec_min?: { readonly __typename?: 'LaminarFlowMetric', readonly avg?: number | null } | null, readonly metric__timestamp_delta_sec_max?: { readonly __typename?: 'LaminarFlowMetric', readonly avg?: number | null } | null } | null }>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly lastCursor?: ReadonlyArray<{ readonly __typename?: 'CursorPart', readonly key: string, readonly value: string }> | null, readonly total: { readonly __typename?: 'Total', readonly relation?: Relation | null, readonly value?: number | null } } } | null };

export const DdxMetricsResultFragmentDoc = gql`
    fragment DDXMetricsResult on DataPlaneDDXMetric {
  endTime
  contactId
  region
  startTime
  jobId
  streamMetrics {
    dataLatency {
      avg
      p99
      p95
      p50
    }
    wanLatency {
      avg
      p99
      p95
      p50
    }
    wanRtt {
      avg
      p99
      p95
      p50
    }
    wanPacketsLost
    wanPacketsReordered
    wanPacketsRepaired
  }
}
    `;
export const LfMetricsResultFragmentDoc = gql`
    fragment LFMetricsResult on DataPlaneLFMetric {
  id
  contact_id
  timeStampStart
  timeStampEnd
  sourceRegion
  destinationRegion
  lfEgressStageMetricsV2 {
    metric__packets_lost_sequence_count {
      max
      total
    }
    metric__last_input_sequence_count {
      max
      total
    }
    metric__timestamp_delta_sec_min {
      avg
    }
    metric__timestamp_delta_sec_max {
      avg
    }
  }
}
    `;
export const AgentDataProductContactReportsDocument = gql`
    query agentDataProductContactReports($input: ContactByIdInput!) {
  getContactById(input: $input) {
    id
    agentPostPassReports {
      agentId
      taskDocumentId
      s3Key
      markdownText
    }
    dataplaneReport {
      htmlText
    }
  }
}
    `;

/**
 * __useAgentDataProductContactReportsQuery__
 *
 * To run a query within a React component, call `useAgentDataProductContactReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgentDataProductContactReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgentDataProductContactReportsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAgentDataProductContactReportsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AgentDataProductContactReportsQuery, AgentDataProductContactReportsQueryVariables> & ({ variables: AgentDataProductContactReportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AgentDataProductContactReportsQuery, AgentDataProductContactReportsQueryVariables>(AgentDataProductContactReportsDocument, options);
      }
export function useAgentDataProductContactReportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AgentDataProductContactReportsQuery, AgentDataProductContactReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AgentDataProductContactReportsQuery, AgentDataProductContactReportsQueryVariables>(AgentDataProductContactReportsDocument, options);
        }
// @ts-ignore
export function useAgentDataProductContactReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AgentDataProductContactReportsQuery, AgentDataProductContactReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AgentDataProductContactReportsQuery, AgentDataProductContactReportsQueryVariables>;
export function useAgentDataProductContactReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AgentDataProductContactReportsQuery, AgentDataProductContactReportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AgentDataProductContactReportsQuery | undefined, AgentDataProductContactReportsQueryVariables>;
export function useAgentDataProductContactReportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AgentDataProductContactReportsQuery, AgentDataProductContactReportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AgentDataProductContactReportsQuery, AgentDataProductContactReportsQueryVariables>(AgentDataProductContactReportsDocument, options);
        }
export type AgentDataProductContactReportsQueryHookResult = ReturnType<typeof useAgentDataProductContactReportsQuery>;
export type AgentDataProductContactReportsLazyQueryHookResult = ReturnType<typeof useAgentDataProductContactReportsLazyQuery>;
export type AgentDataProductContactReportsSuspenseQueryHookResult = ReturnType<typeof useAgentDataProductContactReportsSuspenseQuery>;
export type AgentDataProductContactReportsQueryResult = Apollo.QueryResult<AgentDataProductContactReportsQuery, AgentDataProductContactReportsQueryVariables>;
export const CpsImagesDocument = gql`
    query cpsImages($input: ContactByIdInput!) {
  getContactById(input: $input) {
    id
    images {
      dataflowId
      s3Key
      jobId
      presignedGetUrl
    }
    laminarFlowPlots {
      agentId
      dataflowId
      presignedGetUrl
      plotName
      s3Key
    }
  }
}
    `;

/**
 * __useCpsImagesQuery__
 *
 * To run a query within a React component, call `useCpsImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCpsImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCpsImagesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCpsImagesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CpsImagesQuery, CpsImagesQueryVariables> & ({ variables: CpsImagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CpsImagesQuery, CpsImagesQueryVariables>(CpsImagesDocument, options);
      }
export function useCpsImagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CpsImagesQuery, CpsImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CpsImagesQuery, CpsImagesQueryVariables>(CpsImagesDocument, options);
        }
// @ts-ignore
export function useCpsImagesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CpsImagesQuery, CpsImagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CpsImagesQuery, CpsImagesQueryVariables>;
export function useCpsImagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CpsImagesQuery, CpsImagesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CpsImagesQuery | undefined, CpsImagesQueryVariables>;
export function useCpsImagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CpsImagesQuery, CpsImagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CpsImagesQuery, CpsImagesQueryVariables>(CpsImagesDocument, options);
        }
export type CpsImagesQueryHookResult = ReturnType<typeof useCpsImagesQuery>;
export type CpsImagesLazyQueryHookResult = ReturnType<typeof useCpsImagesLazyQuery>;
export type CpsImagesSuspenseQueryHookResult = ReturnType<typeof useCpsImagesSuspenseQuery>;
export type CpsImagesQueryResult = Apollo.QueryResult<CpsImagesQuery, CpsImagesQueryVariables>;
export const DataplaneVisualizationDocument = gql`
    query dataplaneVisualization($input: ContactByIdInput!) {
  getContactById(input: $input) {
    id
    visualization {
      dataplaneSvgUrlDark
      dataplaneSvgUrlLight
      s3Key
    }
  }
}
    `;

/**
 * __useDataplaneVisualizationQuery__
 *
 * To run a query within a React component, call `useDataplaneVisualizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDataplaneVisualizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDataplaneVisualizationQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDataplaneVisualizationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DataplaneVisualizationQuery, DataplaneVisualizationQueryVariables> & ({ variables: DataplaneVisualizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DataplaneVisualizationQuery, DataplaneVisualizationQueryVariables>(DataplaneVisualizationDocument, options);
      }
export function useDataplaneVisualizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DataplaneVisualizationQuery, DataplaneVisualizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DataplaneVisualizationQuery, DataplaneVisualizationQueryVariables>(DataplaneVisualizationDocument, options);
        }
// @ts-ignore
export function useDataplaneVisualizationSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DataplaneVisualizationQuery, DataplaneVisualizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DataplaneVisualizationQuery, DataplaneVisualizationQueryVariables>;
export function useDataplaneVisualizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DataplaneVisualizationQuery, DataplaneVisualizationQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DataplaneVisualizationQuery | undefined, DataplaneVisualizationQueryVariables>;
export function useDataplaneVisualizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DataplaneVisualizationQuery, DataplaneVisualizationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DataplaneVisualizationQuery, DataplaneVisualizationQueryVariables>(DataplaneVisualizationDocument, options);
        }
export type DataplaneVisualizationQueryHookResult = ReturnType<typeof useDataplaneVisualizationQuery>;
export type DataplaneVisualizationLazyQueryHookResult = ReturnType<typeof useDataplaneVisualizationLazyQuery>;
export type DataplaneVisualizationSuspenseQueryHookResult = ReturnType<typeof useDataplaneVisualizationSuspenseQuery>;
export type DataplaneVisualizationQueryResult = Apollo.QueryResult<DataplaneVisualizationQuery, DataplaneVisualizationQueryVariables>;
export const ListDdxMetricsDocument = gql`
    query listDDXMetrics($where: DataPlaneDDXMetricFilterInput!, $cursor: [CursorPartInput!], $sort: [DataPlaneDDXMetricSortInput!], $limit: Int) {
  listDataPlaneDDXMetric(
    input: {limit: $limit, where: $where, sort: $sort, cursor: $cursor}
  ) {
    results {
      ...DDXMetricsResult
    }
    pageInfo {
      hasNextPage
      lastCursor {
        key
        value
      }
      total {
        relation
        value
      }
    }
  }
}
    ${DdxMetricsResultFragmentDoc}`;

/**
 * __useListDdxMetricsQuery__
 *
 * To run a query within a React component, call `useListDdxMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDdxMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDdxMetricsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListDdxMetricsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListDdxMetricsQuery, ListDdxMetricsQueryVariables> & ({ variables: ListDdxMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListDdxMetricsQuery, ListDdxMetricsQueryVariables>(ListDdxMetricsDocument, options);
      }
export function useListDdxMetricsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListDdxMetricsQuery, ListDdxMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListDdxMetricsQuery, ListDdxMetricsQueryVariables>(ListDdxMetricsDocument, options);
        }
// @ts-ignore
export function useListDdxMetricsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ListDdxMetricsQuery, ListDdxMetricsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ListDdxMetricsQuery, ListDdxMetricsQueryVariables>;
export function useListDdxMetricsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ListDdxMetricsQuery, ListDdxMetricsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ListDdxMetricsQuery | undefined, ListDdxMetricsQueryVariables>;
export function useListDdxMetricsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ListDdxMetricsQuery, ListDdxMetricsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ListDdxMetricsQuery, ListDdxMetricsQueryVariables>(ListDdxMetricsDocument, options);
        }
export type ListDdxMetricsQueryHookResult = ReturnType<typeof useListDdxMetricsQuery>;
export type ListDdxMetricsLazyQueryHookResult = ReturnType<typeof useListDdxMetricsLazyQuery>;
export type ListDdxMetricsSuspenseQueryHookResult = ReturnType<typeof useListDdxMetricsSuspenseQuery>;
export type ListDdxMetricsQueryResult = Apollo.QueryResult<ListDdxMetricsQuery, ListDdxMetricsQueryVariables>;
export const ListLfMetricsDocument = gql`
    query listLFMetrics($where: DataPlaneLFMetricFilterInput!, $cursor: [CursorPartInput!], $sort: [DataPlaneLFMetricSortInput!], $limit: Int) {
  listDataPlaneLFMetric(
    input: {limit: $limit, where: $where, sort: $sort, cursor: $cursor}
  ) {
    results {
      ...LFMetricsResult
    }
    pageInfo {
      hasNextPage
      lastCursor {
        key
        value
      }
      total {
        relation
        value
      }
    }
  }
}
    ${LfMetricsResultFragmentDoc}`;

/**
 * __useListLfMetricsQuery__
 *
 * To run a query within a React component, call `useListLfMetricsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListLfMetricsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListLfMetricsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      cursor: // value for 'cursor'
 *      sort: // value for 'sort'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useListLfMetricsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ListLfMetricsQuery, ListLfMetricsQueryVariables> & ({ variables: ListLfMetricsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ListLfMetricsQuery, ListLfMetricsQueryVariables>(ListLfMetricsDocument, options);
      }
export function useListLfMetricsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ListLfMetricsQuery, ListLfMetricsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ListLfMetricsQuery, ListLfMetricsQueryVariables>(ListLfMetricsDocument, options);
        }
// @ts-ignore
export function useListLfMetricsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ListLfMetricsQuery, ListLfMetricsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ListLfMetricsQuery, ListLfMetricsQueryVariables>;
export function useListLfMetricsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ListLfMetricsQuery, ListLfMetricsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ListLfMetricsQuery | undefined, ListLfMetricsQueryVariables>;
export function useListLfMetricsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ListLfMetricsQuery, ListLfMetricsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ListLfMetricsQuery, ListLfMetricsQueryVariables>(ListLfMetricsDocument, options);
        }
export type ListLfMetricsQueryHookResult = ReturnType<typeof useListLfMetricsQuery>;
export type ListLfMetricsLazyQueryHookResult = ReturnType<typeof useListLfMetricsLazyQuery>;
export type ListLfMetricsSuspenseQueryHookResult = ReturnType<typeof useListLfMetricsSuspenseQuery>;
export type ListLfMetricsQueryResult = Apollo.QueryResult<ListLfMetricsQuery, ListLfMetricsQueryVariables>;